/* instanbul ignore file */
import {
    SignupClient
} from '@nuskin/ns-signup-api-client';

import appStage, {clientId} from '../config/appStage.js';

let client;

/* istanbul ignore else */
if (process.env.mockApi && process.env.mockApi === 'true') {
    client = SignupClient.mock();
} else {
    client = new SignupClient({
        stage: appStage.service,
        clientId
    });
}

/**
 * @constant {SignupClient}
 */
export default client;
